import { Helmet } from 'react-helmet-async';
import React from 'react';
import ChangeInsightsSurveyContainer from '../../../../containers/change-insights/ChangeInsightsSurveyContainer.jsx';

import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

const SurveySettings = ({ slug }) => {
  return (
    <>
      <Helmet>
        <title>Preview Add Feedback Form Template | ChangeSync</title>
      </Helmet>
      <ChangeInsightsSurveyContainer
        slug={slug}
        isPreview="new"
        isPreviewTemplate
      />
    </>
  );
};

SurveySettings.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(SurveySettings));
